import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { VesTransactionsService, VesTransactionItem } from '../../../services/ves-transactions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reject-swap-modal',
  templateUrl: './reject-swap-modal.component.html',
  styleUrls: ['./reject-swap-modal.component.sass'],
})
export class RejectSwapModalComponent {
  transaction: VesTransactionItem;
  reasonForm: FormGroup;
  loading = false;

  constructor(
    private vesTransactionsService: VesTransactionsService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<RejectSwapModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VesTransactionItem,
  ) {
    this.transaction = data;
    this.reasonForm = this.fb.group({
      reason: new FormControl('', [Validators.required, Validators.minLength(3)]),
    });
  }

  formatVES(amount: number | null | undefined): string {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('es-VE', {
      style: 'currency',
      currency: 'VES',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  get isRetiroVes(): boolean {
    return this.transaction.type === 'RETIRO_VES';
  }

  rejectSwap(): void {
    if (this.reasonForm.invalid || this.loading) return;
    this.loading = true;

    const reason = this.reasonForm.get('reason')?.value;

    const request$ = this.isRetiroVes
      ? this.vesTransactionsService.rejectRetiroVes(this.transaction.id, reason)
      : this.vesTransactionsService.rejectSwap(this.transaction.id, reason);

    request$.subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.isRetiroVes ? 'Retiro VES rechazado' : 'Swap rechazado',
          text: 'La transacción ha sido rechazada',
          showCancelButton: false,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1e5a3f',
        });
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.loading = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: err.message || 'Error al rechazar la transacción',
          showCancelButton: false,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#1e5a3f',
        });
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
